import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

export default function AppendixB({ styles, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix B</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>Special Provision Description</Text>
        </View>
        <View style={styles.section}>
          <Text>
            The District staff requires a special provision on any wells that
            are in Regulatory{' '}
            {window.config.client === 'FT-BEND' ? 'Area A' : 'Areas 1, 2, or 3'}{' '}
            that have an allocation greater than 10.0 MG per year or a total
            pumpage greater than 5.0 MG, or have not converted to alternate
            water. The special provision is as follows:
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.paragraph}>
            {window.config.client === 'FT-BEND' ? (
              <>
                On August 28, 2013 the Board of Directors of the Fort Bend
                Subsidence District adopted the 2013 District Regulatory Plan.
                You can obtain a copy of the 2013 District Plan at our web site
                https://www.fbsubsidence.org . If you have any questions or if
                you do not have access to the Internet, you can contact the
                District office at 281-342-3273.
              </>
            ) : (
              <>
                On January 9, 2013 the Board of Directors of the Subsidence
                District adopted the 2013 District Regulatory Plan. There have
                been significant changes between the 1999 and the 2013 District
                Plans. As a result, some of the changes may directly affect you.
                You can obtain a copy of the 2013 District Plan at our web site
                www.subsidence.org. If you have any questions or if you do not
                have access to the Internet, you can contact the Subsidence
                District's office.
              </>
            )}
          </Text>
        </View>
        <View style={styles.section}>
          <Text>
            This provision may not have been included on every recommendation
            (meeting the above criteria) in this Hearing Examiner's Report, but
            the provision is required for these wells and is considered a part
            of staff's recommendation for each well that meets the criteria. The
            provision will be included on the permit for each well that meets
            the criteria.
          </Text>
        </View>
        <View style={styles.section}>
          <Text>Other provisions are as follows:</Text>
        </View>
        <View style={styles.section}>
          <View style={[styles.row, styles.borderBottom]}>
            <Text style={styles.column}>PROVISION</Text>
            <Text style={styles.column}>DESCRIPTION</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-40</Text>
            <Text style={styles.column}>
              Limited to no more than 40% of the total water demand.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-70</Text>
            <Text style={styles.column}>
              Limited to no more than 70% of the total water demand-These
              permittees have a Groundwater Reduction Plan (GRP).
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-A</Text>
            <Text style={styles.column}>
              Permittee is required to submit a report on how they can improve
              the accountability of the water system. The accountability is the
              amount of water that billed (accounted for through meter readings)
              versus pumped from their wells or other sources.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>
              {window.config.client === 'FT-BEND' ? 'PROV-D2' : 'PROV-D1'}
            </Text>
            <Text style={styles.column}>
              This provision is used to make permittees aware that the District
              has updated its District Plan. This provision is added to those
              permittees with an allocation between 5.0 and 10.0 MG that are
              located in Regulatory Area A.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-DF6</Text>
            <Text style={styles.column}>
              Limited to no more than 40% of the total water demand plus an
              additional amount of water covered by the permittee paying the
              disincentive fee.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-E</Text>
            <Text style={styles.column}>
              The authorized allocation is for the total aggregate system.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-F</Text>
            <Text style={styles.column}>
              This provision is used to make permittees aware that there might
              be violation associated with the permit.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-G</Text>
            <Text style={styles.column}>
              Provision giving the permittee notice that by a certain date they
              will be ordered to reduce their groundwater usage by 60% of the
              total water demand.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-G1A</Text>
            <Text style={styles.column}>
              This provision is used for those permittees stating that they are
              exempt from paying the disincentive fee because they have an
              approved (GRP). The "A" refers to the 2013 Regulatory Plan.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-G2</Text>
            <Text style={styles.column}>
              This provision is used when a permittee has a groundwater
              reduction agreement with another permittee. The permittee would
              pay the other permittee to over convert, so that the first
              permittee can remain on groundwater. Currently, there are no
              agreements of this type in the District.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-G4</Text>
            <Text style={styles.column}>
              Limited to no more than 40% of the total water demand plus an
              additional amount of water covered by the permittee using
              groundwater credits/paying the disincentive fee.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-JASP1</Text>
            <Text style={styles.column}>
              This provision is currently used for only one well in the
              District, that is drilled into the Jasper Aquifer.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-M</Text>
            <Text style={styles.column}>
              Giving the permittee notice that they have 60 days to install a
              meter.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-O</Text>
            <Text style={styles.column}>
              Giving the permittee notice that they until a certain date to
              install a meter.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-SP40</Text>
            <Text style={styles.column}>
              Limited to no more than 40% of the total water demand plus an
              additional amount of water covered by the permittee's use of
              groundwater credits.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.column}>PROV-U1</Text>
            <Text style={styles.column}>
              Provision requesting that the permittee submit a report on what
              options that may be available to them, other than groundwater.
            </Text>
          </View>
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
